// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  -webkit-tap-highlight-color: transparent !important;
  -webkit-font-smoothing: antialiased !important; }

.header-mp {
  height: 60px;
  background-color: #ffffff !important; }

.list-item-link:hover {
  color: black;
  text-decoration: underline; }

.list-item-link {
  overflow: hidden;
  width: auto;
  cursor: pointer;
  padding-right: 50%; }

.ant-list-item-action {
  margin-left: auto; }

.generic-list-item {
  padding-left: 2em; }

.add-to-list-icon {
  font-size: 3em;
  text-align: center; }

.ant-card-meta-description {
  height: 100px; }

.add-to-list-text {
  font-size: 1em;
  text-align: center;
  font-weight: normal; }

.ant-card-meta-description {
  height: 100px; }

.header-comp {
  margin: 5px !important;
  position: relative !important;
  height: 3em !important; }

.header-style-1 {
  font-size: 2em;
  vertical-align: middle;
  text-align: center; }

.logo-mp {
  height: 100%;
  padding: 0.5em;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%); }

.profile-img-mp {
  margin-top: 10px !important;
  box-shadow: 0 0 28px 0 rgba(52, 49, 74, 0.32);
  background-color: var(--main-bg-color) !important; }

.profile-icon-mp {
  font-size: 1rem !important;
  padding-left: 3%;
  padding-top: 15px; }

.filter-mp {
  background-color: var(--main-bg-color);
  border-width: 1px !important;
  border-color: rgba(19, 144, 228, 0.863) !important; }
  .filter-mp button {
    background-color: var(--main-bg-color);
    color: white;
    border: none; }

.user-menu-drop-down {
  position: absolute;
  top: 50%;
  transform: translateY(-25%);
  width: 100%;
  text-align: right; }

.scanner-list {
  color: #eeeff8 !important;
  background-color: #eeeff8;
  padding: 15px !important; }

.viewer-controls {
  height: 105vh;
  background-color: white;
  border-right: 1px solid #f5f5f5;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  text-align: center; }

.viewer-right-sidebar {
  height: auto;
  background-color: var(--main-bg-color);
  padding: 0.5em; }

.less-padded-ant-card-body > .ant-card-body {
  padding: 2px !important;
  font-size: .8rem; }

.zero-padded-ant-card-body > .ant-card-body {
  padding: 0px !important;
  font-size: .5rem; }

.ant-card-body {
  padding: 10px !important;
  font-size: .8rem; }

.sidebar-card {
  height: auto;
  background-color: white;
  border-radius: 0.5em; }

.slide-info {
  margin-top: 0.5em; }

.ant-card-cover {
  border: 5px solid #ffffff; }

.header-fixed-mp {
  z-index: 1; }

#components-form-demo-normal-login .login-form {
  max-width: 300px; }

#components-form-demo-normal-login .login-form-forgot {
  float: right; }

#components-form-demo-normal-login .login-form-button {
  width: 100%; }

.login-mp {
  padding-top: 5%;
  padding-left: 5%;
  background-color: #d4d5d9 !important;
  height: 100%;
  padding-right: 5%; }

.login-logo-mp {
  height: 80px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 15%; }

form input {
  height: 45px !important; }

.device-mp {
  height: auto !important;
  background-color: var(--main-bg-color);
  border-radius: 3px;
  margin-top: 4% !important;
  margin-bottom: 5%; }

.scanner-heading-mp {
  text-align: center;
  font-size: 1rem; }

.ant-card-cover {
  background-color: #f5f5f5; }

.whoop-mp {
  height: 100px;
  margin-top: 12%; }

.link-details-mp {
  color: black; }

.link-details-mp:hover {
  color: black;
  text-decoration: none; }

.nav-mp {
  height: 100%;
  width: 100%; }

.ant-slider-mark {
  font-size: 0.6rem !important; }

.ant-slider-vertical .ant-slider-mark {
  left: 6px !important;
  width: 15px !important; }

.ant-slider-vertical {
  margin: 25px 6px !important;
  padding: 0 0 !important; }

.icon-mp {
  font-size: 0.8rem !important;
  padding: 7px; }

.ant-divider-horizontal {
  margin: 5px 0 !important; }

.search-sugg-mp {
  background-color: white;
  z-index: 10;
  height: auto;
  position: absolute !important;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  border-color: rgba(0, 0, 0, 0.09); }

#shapeone {
  width: 5px;
  background-color: blue; }

.ant-list-split .ant-list-header {
  border-bottom: none !important; }

.view-sidebar {
  border-width: 1px !important;
  border-color: rgba(129, 129, 129, 0.863) !important;
  background-color: white !important;
  color: #3a3a3a !important;
  height: 8% !important;
  width: 60% !important;
  border-radius: 5px !important;
  margin: 2px !important; }

.view-sidebar-selected {
  border-color: rgba(19, 144, 228, 0.863) !important;
  border-width: 2px !important; }

.view-sidebar:hover {
  border-color: rgba(19, 144, 228, 0.863) !important;
  border-width: 2px !important; }

.grid-size {
  font-size: 0.8em; }

.stop-draw-btn {
  height: 8% !important;
  width: 100% !important;
  border-radius: 5px !important;
  margin: 2px !important; }

.zoom-btn-mp {
  height: 15% !important;
  width: 65% !important; }

.anno-btn-mp > i {
  color: white; }

.hidden-mp {
  display: none; }

#delete-anno-mp {
  float: right;
  font-size: .7rem;
  margin-top: 3%;
  color: #4474F3;
  cursor: pointer; }

.uploadProgress {
  width: 20px !important;
  height: 20px !important; }

.ant-card-cover {
  min-height: 111px; }

.ant-card-meta-description {
  max-height: 100px;
  min-height: 60px;
  overflow-y: auto; }

#card-tag-mp {
  height: 68px; }

.zoom-slider {
  display: flex;
  height: 200px;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: 20px;
  margin-bottom: 20px; }

.controls-header {
  color: black;
  font-size: .67rem;
  text-align: center;
  padding-top: 5px;
  margin-bottom: 2px; }

.sidebar-textbutton {
  white-space: normal;
  padding: 0;
  font-size: 11px;
  width: 95% !important; }

.sidebar-digizoom {
  border-color: #d95a00 !important;
  border-width: 2px !important;
  white-space: normal;
  padding: 0;
  font-size: 11px;
  width: 95% !important; }

.sidebar-digizoom:hover {
  border-color: #e87902 !important;
  border-width: 3px !important; }

.controls-text {
  color: black;
  font-size: .6rem;
  text-align: center;
  padding-top: 5px; }

.editorClass {
  background: white !important; }
`, "",{"version":3,"sources":["webpack://./src/asset/style/style.scss"],"names":[],"mappings":"AAAA;EACE,mDAAmD;EACnD,8CAA8C,EAAE;;AAElD;EACE,YAAY;EACZ,oCAAoC,EAAE;;AAExC;EACE,YAAY;EACZ,0BAA0B,EAAE;;AAE9B;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,aAAa,EAAE;;AAEjB;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB,EAAE;;AAE1B;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC,EAAE;;AAEpC;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,iDAAiD,EAAE;;AAErD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB,EAAE;;AAErB;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,kDAAkD,EAAE;EACpD;IACE,sCAAsC;IACtC,YAAY;IACZ,YAAY,EAAE;;AAElB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,iBAAiB,EAAE;;AAErB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB,EAAE;;AAE5B;EACE,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB,EAAE;;AAEtB;EACE,YAAY;EACZ,sCAAsC;EACtC,cAAc,EAAE;;AAElB;EACE,uBAAuB;EACvB,gBAAgB,EAAE;;AAEpB;EACE,uBAAuB;EACvB,gBAAgB,EAAE;;AAEpB;EACE,wBAAwB;EACxB,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB,EAAE;;AAExB;EACE,iBAAiB,EAAE;;AAErB;EACE,yBAAyB,EAAE;;AAE7B;EACE,UAAU,EAAE;;AAEd;EACE,gBAAgB,EAAE;;AAEpB;EACE,YAAY,EAAE;;AAEhB;EACE,WAAW,EAAE;;AAEf;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB,EAAE;;AAEtB;EACE,uBAAuB,EAAE;;AAE3B;EACE,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;;AAE7B;EACE,aAAa;EACb,eAAe,EAAE;;AAEnB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY;EACZ,qBAAqB,EAAE;;AAEzB;EACE,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,4BAA4B,EAAE;;AAEhC;EACE,oBAAoB;EACpB,sBAAsB,EAAE;;AAE1B;EACE,2BAA2B;EAC3B,uBAAuB,EAAE;;AAE3B;EACE,4BAA4B;EAC5B,YAAY,EAAE;;AAEhB;EACE,wBAAwB,EAAE;;AAE5B;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,yCAAyC;EACzC,iCAAiC,EAAE;;AAErC;EACE,UAAU;EACV,sBAAsB,EAAE;;AAE1B;EACE,8BAA8B,EAAE;;AAElC;EACE,4BAA4B;EAC5B,mDAAmD;EACnD,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB,EAAE;;AAE1B;EACE,kDAAkD;EAClD,4BAA4B,EAAE;;AAEhC;EACE,kDAAkD;EAClD,4BAA4B,EAAE;;AAEhC;EACE,gBAAgB,EAAE;;AAEpB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB;EACtB,qBAAqB,EAAE;;AAEzB;EACE,YAAY,EAAE;;AAEhB;EACE,aAAa,EAAE;;AAEjB;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,sBAAsB;EACtB,uBAAuB,EAAE;;AAE3B;EACE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,YAAY,EAAE;;AAEhB;EACE,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB,EAAE;;AAEvB;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,qBAAqB,EAAE;;AAEzB;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,qBAAqB,EAAE;;AAEzB;EACE,gCAAgC;EAChC,4BAA4B,EAAE;;AAEhC;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,4BAA4B,EAAE","sourcesContent":["* {\n  -webkit-tap-highlight-color: transparent !important;\n  -webkit-font-smoothing: antialiased !important; }\n\n.header-mp {\n  height: 60px;\n  background-color: #ffffff !important; }\n\n.list-item-link:hover {\n  color: black;\n  text-decoration: underline; }\n\n.list-item-link {\n  overflow: hidden;\n  width: auto;\n  cursor: pointer;\n  padding-right: 50%; }\n\n.ant-list-item-action {\n  margin-left: auto; }\n\n.generic-list-item {\n  padding-left: 2em; }\n\n.add-to-list-icon {\n  font-size: 3em;\n  text-align: center; }\n\n.ant-card-meta-description {\n  height: 100px; }\n\n.add-to-list-text {\n  font-size: 1em;\n  text-align: center;\n  font-weight: normal; }\n\n.ant-card-meta-description {\n  height: 100px; }\n\n.header-comp {\n  margin: 5px !important;\n  position: relative !important;\n  height: 3em !important; }\n\n.header-style-1 {\n  font-size: 2em;\n  vertical-align: middle;\n  text-align: center; }\n\n.logo-mp {\n  height: 100%;\n  padding: 0.5em;\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\n.profile-img-mp {\n  margin-top: 10px !important;\n  box-shadow: 0 0 28px 0 rgba(52, 49, 74, 0.32);\n  background-color: var(--main-bg-color) !important; }\n\n.profile-icon-mp {\n  font-size: 1rem !important;\n  padding-left: 3%;\n  padding-top: 15px; }\n\n.filter-mp {\n  background-color: var(--main-bg-color);\n  border-width: 1px !important;\n  border-color: rgba(19, 144, 228, 0.863) !important; }\n  .filter-mp button {\n    background-color: var(--main-bg-color);\n    color: white;\n    border: none; }\n\n.user-menu-drop-down {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-25%);\n  width: 100%;\n  text-align: right; }\n\n.scanner-list {\n  color: #eeeff8 !important;\n  background-color: #eeeff8;\n  padding: 15px !important; }\n\n.viewer-controls {\n  height: 105vh;\n  background-color: white;\n  border-right: 1px solid #f5f5f5;\n  border-bottom-left-radius: 5px;\n  border-top-left-radius: 5px;\n  text-align: center; }\n\n.viewer-right-sidebar {\n  height: auto;\n  background-color: var(--main-bg-color);\n  padding: 0.5em; }\n\n.less-padded-ant-card-body > .ant-card-body {\n  padding: 2px !important;\n  font-size: .8rem; }\n\n.zero-padded-ant-card-body > .ant-card-body {\n  padding: 0px !important;\n  font-size: .5rem; }\n\n.ant-card-body {\n  padding: 10px !important;\n  font-size: .8rem; }\n\n.sidebar-card {\n  height: auto;\n  background-color: white;\n  border-radius: 0.5em; }\n\n.slide-info {\n  margin-top: 0.5em; }\n\n.ant-card-cover {\n  border: 5px solid #ffffff; }\n\n.header-fixed-mp {\n  z-index: 1; }\n\n#components-form-demo-normal-login .login-form {\n  max-width: 300px; }\n\n#components-form-demo-normal-login .login-form-forgot {\n  float: right; }\n\n#components-form-demo-normal-login .login-form-button {\n  width: 100%; }\n\n.login-mp {\n  padding-top: 5%;\n  padding-left: 5%;\n  background-color: #d4d5d9 !important;\n  height: 100%;\n  padding-right: 5%; }\n\n.login-logo-mp {\n  height: 80px;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin-bottom: 15%; }\n\nform input {\n  height: 45px !important; }\n\n.device-mp {\n  height: auto !important;\n  background-color: var(--main-bg-color);\n  border-radius: 3px;\n  margin-top: 4% !important;\n  margin-bottom: 5%; }\n\n.scanner-heading-mp {\n  text-align: center;\n  font-size: 1rem; }\n\n.ant-card-cover {\n  background-color: #f5f5f5; }\n\n.whoop-mp {\n  height: 100px;\n  margin-top: 12%; }\n\n.link-details-mp {\n  color: black; }\n\n.link-details-mp:hover {\n  color: black;\n  text-decoration: none; }\n\n.nav-mp {\n  height: 100%;\n  width: 100%; }\n\n.ant-slider-mark {\n  font-size: 0.6rem !important; }\n\n.ant-slider-vertical .ant-slider-mark {\n  left: 6px !important;\n  width: 15px !important; }\n\n.ant-slider-vertical {\n  margin: 25px 6px !important;\n  padding: 0 0 !important; }\n\n.icon-mp {\n  font-size: 0.8rem !important;\n  padding: 7px; }\n\n.ant-divider-horizontal {\n  margin: 5px 0 !important; }\n\n.search-sugg-mp {\n  background-color: white;\n  z-index: 10;\n  height: auto;\n  position: absolute !important;\n  width: 100%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);\n  border-color: rgba(0, 0, 0, 0.09); }\n\n#shapeone {\n  width: 5px;\n  background-color: blue; }\n\n.ant-list-split .ant-list-header {\n  border-bottom: none !important; }\n\n.view-sidebar {\n  border-width: 1px !important;\n  border-color: rgba(129, 129, 129, 0.863) !important;\n  background-color: white !important;\n  color: #3a3a3a !important;\n  height: 8% !important;\n  width: 60% !important;\n  border-radius: 5px !important;\n  margin: 2px !important; }\n\n.view-sidebar-selected {\n  border-color: rgba(19, 144, 228, 0.863) !important;\n  border-width: 2px !important; }\n\n.view-sidebar:hover {\n  border-color: rgba(19, 144, 228, 0.863) !important;\n  border-width: 2px !important; }\n\n.grid-size {\n  font-size: 0.8em; }\n\n.stop-draw-btn {\n  height: 8% !important;\n  width: 100% !important;\n  border-radius: 5px !important;\n  margin: 2px !important; }\n\n.zoom-btn-mp {\n  height: 15% !important;\n  width: 65% !important; }\n\n.anno-btn-mp > i {\n  color: white; }\n\n.hidden-mp {\n  display: none; }\n\n#delete-anno-mp {\n  float: right;\n  font-size: .7rem;\n  margin-top: 3%;\n  color: #4474F3;\n  cursor: pointer; }\n\n.uploadProgress {\n  width: 20px !important;\n  height: 20px !important; }\n\n.ant-card-cover {\n  min-height: 111px; }\n\n.ant-card-meta-description {\n  max-height: 100px;\n  min-height: 60px;\n  overflow-y: auto; }\n\n#card-tag-mp {\n  height: 68px; }\n\n.zoom-slider {\n  display: flex;\n  height: 200px;\n  margin-left: auto !important;\n  margin-right: auto !important;\n  margin-top: 20px;\n  margin-bottom: 20px; }\n\n.controls-header {\n  color: black;\n  font-size: .67rem;\n  text-align: center;\n  padding-top: 5px;\n  margin-bottom: 2px; }\n\n.sidebar-textbutton {\n  white-space: normal;\n  padding: 0;\n  font-size: 11px;\n  width: 95% !important; }\n\n.sidebar-digizoom {\n  border-color: #d95a00 !important;\n  border-width: 2px !important;\n  white-space: normal;\n  padding: 0;\n  font-size: 11px;\n  width: 95% !important; }\n\n.sidebar-digizoom:hover {\n  border-color: #e87902 !important;\n  border-width: 3px !important; }\n\n.controls-text {\n  color: black;\n  font-size: .6rem;\n  text-align: center;\n  padding-top: 5px; }\n\n.editorClass {\n  background: white !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
